import type { Locale } from '@/types/dictionary';

export default function getLocale(value: string | Record<Locale, string>, locale: Locale) {
  return typeof value === 'object' ? value[locale] || '' : value || '';
}
